var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilverPlatter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 411.38 510.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1edff;}.cls-1,.cls-2{stroke-width:1.17px;}.cls-1,.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-2,.cls-4,.cls-5,.cls-6,.cls-7{stroke:#218cff;}.cls-2{fill:#b8d9ff;}.cls-8{stroke:#386aff;}.cls-8,.cls-4,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-8,.cls-7{fill:#fff;}.cls-3{stroke:#ece70d;stroke-width:3px;}.cls-3,.cls-6,.cls-9{fill:none;}.cls-4{fill:rgba(255,255,255,.35);}.cls-4,.cls-5,.cls-6,.cls-7{stroke-width:1.17px;}.cls-5{fill:#e6e6e6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183.83,66.46c7.99-3.47,14.94-7.12,23.36-4.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.32,20.52c26.72,10.47,55.53,15.54,84.22,14.82,2.69-.07,5.66-.09,7.69,1.67,2.48,2.15,2.45,6.07,1.28,9.14-1.94,5.11-6.57,9.12-11.9,10.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M211.51,16.46c19.41,4.06,39.76,8.81,58.93,3.73,2.31-.61,4.65-1.3,7.05-1.22s4.9,1.05,6.16,3.08c1.5,2.41,.85,5.67-.81,7.97s-4.13,3.85-6.55,5.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M203.27,34.43c14.04,9.82,28.52,10.56,37.13,18.46s37.58,13.16,37.58,13.16c0,0,6.11,3.12,11.09,4.98s28.75-1,28.3-9.74-32.15-9.06-37.55-11.6-31.79-12.85-31.79-12.85c0,0-11.26-7.25-16.76-10.87s-26.65-13.58-26.65-13.58c0,0-12.23-11.32-18.11-11.77s-15.85,5.43-20.38,8.15-61.58,30.79-71.09,29.89c0,0-31.13,6.51-58.3,1.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184.78,56.38c-5.18,10.55-4.89,28.04,0,38.73h0c5.06,6.65,11.29,12.18,18.21,17.55,10.56,8.19,20.42,15.73,28.13,26.91,10.94,12.28,9.78,16.73-9.81,14.47-6.68-.77-19.04-8.69-24.8-15.68-3-3.65-6.83-6.54-12.01-8.95-7.47-3.48-10.17-4.89-21.18-6.49-1.94-.28-4.26-.62-6.8-1.05h-.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M361.5,324.19c-9.51,1.64-46.64,35.04-49.81,38.67-3.17,3.62-17.66,8.15-27.17,11.77-9.51,3.62-22.19,19.02-29.89,24.9-7.7,5.89-58.41,27.63-64.72,28.99-5.53,1.18-44.13,26.43-53.52,32.6,.19-2.29,.18-4.61,.14-6.92-.19-11.18-.85-22.35-1.99-33.46-.17-1.74-.65-8.07-3.08-7.62,0,0,17.21-14.49,20.38-19.47,3.17-4.98-4.24-16.31,5.26-23.1,1.5-1.07,12.37-5.11,15.32-13.32,3.12-8.68-1.23-15.21-5.74-19.17-3.96-3.48-20.74-10.3-17.34-13.13,3.4-2.83,16.98-1.93,24.45,0,5.12,1.32,23.83,14.22,27,25.77,0,0,15.31,5.13,23.89,2.99,4.92-1.23,19.88-18.63,43.43-24.83,42.33-11.15,88.77-13.28,88.77-13.28,5.04-1.36,8.53-1.93,9.14-1.62,1.81,.91,4.98,8.6-4.53,10.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M241.23,359.47c6.61-4.58,15.13-5.18,23.17-5.39,8.05-.22,16.47-.31,23.55-4.14,4.69-2.54,8.39-6.52,12.15-10.3,6.64-6.66,13.74-12.88,21.22-18.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M256.52,354.53c8.25-5.68,15.16-4.79,22.94-11.42,3.28-2.79,5.53-6.56,8.39-9.77,5.24-5.91,12.35-9.78,19.3-13.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 88.69,
    y: 307.95,
    width: 322.1,
    height: 16.98,
    rx: 8.49,
    ry: 8.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M217.65,380.67s5.13-5.13,14.79-6.64,15.93-3.02,15.93-3.02c0,0,4-4.53,7.92-9.66,3.92-5.13,7.85-8.45,7.85-8.45,0,0-.3-7.85,5.13-13.89s14.79-19.92,22.64-18.11-19.02,38.94-21.13,49.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200.88,351.51c3.42,5.8,4.81,12.77,3.87,19.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M156.63,121.89s-18.76-1.26-24.19-2.78-14.19-7.84-14.19-7.84c-4.72-3.14-21.13-3.77-21.74-3.62,0,0-41.96-.91-54.94,1.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.38,461.28c-.1,1.48-.3,2.92-.59,4.27-.23,1.08-.6,2.31-1.64,3.18-.66,.54-1.47,.83-2.34,.83-14.86,11.84-74.57,26.42-74.57,26.42v-61.35s8.37,.68,21.28-3.4c11.44-3.62,42.35-16.6,49.2-19.48h.01c.75-.33,1.21-.52,1.32-.57,.02-.01,.03-.01,.03-.01,.22-.04,.43-.06,.63-.06,3.93,0,4.52,6.2,4.8,9.18l.02,.25c1.14,11.07,1.81,22.38,2,33.62,.04,2.15,.06,4.64-.15,7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M129.03,470.05c-.12,1.71-.35,3.38-.69,4.94-.25,1.24-.68,2.67-1.89,3.67-.76,.62-1.69,.96-2.7,.96-17.17,13.68-123.16,30.53-123.16,30.53v-82.54s60.68-1.96,77.29-4.38c14.71-2.15,36.91-9.19,41.76-10.76,.03-.02,.06-.03,.09-.03,.4-.14,.67-.22,.79-.27,.05-.01,.08-.02,.08-.02,.25-.05,.49-.07,.73-.07,4.53,0,5.21,7.16,5.54,10.6l.02,.3c1.32,12.78,2.09,25.86,2.32,38.85,.04,2.48,.06,5.36-.18,8.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 26.4,
    y: 37.54,
    width: 52.3,
    height: 86.55,
    rx: 4.5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M66.49,131.03L.59,146.67V29.84H66.42c2.48,0,4.5,2.03,4.5,4.5V125.42c0,2.67-1.84,5-4.44,5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M194.43,258.37l110.77-13.85s-16.99,54.42-17.45,54.42-84.8,2.72-84.8,2.72l-8.52-43.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M401.72,262.31c.49,3.86-67.32,15.55-151.45,26.13-84.13,10.58-152.73,16.04-153.21,12.19v-.04c0-3.9,67.62-15.56,151.45-26.09,84.14-10.58,152.73-16.04,153.21-12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.45,298.79c22.05-4.96,71.76-13.07,137.43-21.31,59.41-7.47,113.5-12.66,138.42-13.33-22.06,4.96-71.76,13.06-137.41,21.31-59.41,7.47-113.52,12.66-138.44,13.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "244.5 300.19 185.98 237.54 225 237.54 244.5 300.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "303.03 237.54 244.5 300.19 264.01 237.54 303.03 237.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "303.02 237.54 185.98 237.54 205.49 210.55 205.49 210.55 283.52 210.55 303.02 237.54"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "225 237.54 185.98 237.54 205.49 210.55 205.49 210.55 225 237.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "264.01 237.54 225 237.54 244.5 210.55 264.01 237.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "303.03 237.54 264.01 237.54 283.52 210.55 303.03 237.54"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "264.01 237.54 244.5 300.19 225 237.54 264.01 237.54"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 280.97,
    y1: 189.58,
    x2: 280.97,
    y2: 198.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 285.37,
    y1: 193.99,
    x2: 276.56,
    y2: 193.99
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 299.53,
    y1: 207.93,
    x2: 299.53,
    y2: 215.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 303.4,
    y1: 211.8,
    x2: 295.65,
    y2: 211.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 306.23,
    y1: 184.5,
    x2: 306.23,
    y2: 191.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 309.79,
    y1: 188.07,
    x2: 302.66,
    y2: 188.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 193.71,
    y1: 268.09,
    x2: 193.71,
    y2: 275.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 197.27,
    y1: 271.66,
    x2: 190.14,
    y2: 271.66
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 170.62,
    y1: 270.35,
    x2: 170.62,
    y2: 275.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 173.36,
    y1: 273.09,
    x2: 167.89,
    y2: 273.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 178.41,
    y1: 254.56,
    x2: 178.41,
    y2: 262.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 182.26,
    y1: 258.42,
    x2: 174.55,
    y2: 258.42
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 228.63,
    cy: 145.1,
    r: 10.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M401.72,262.31c-.48-3.85-69.07,1.61-153.21,12.19-83.83,10.53-151.45,22.19-151.45,26.09-.88-7.01-1.31-13.94-1.31-20.76,0-62.59,35.95-114.92,86.45-121.28l101.86-12.81c56-7.04,108.68,45.15,117.66,116.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M179.26,12.23c3.17-1.81,10.42-3.47,12.83-2.87s6.79,3.16,7.85,7.09,2.87,4.06,2.87,4.06c0,0,28.38,28.24,31.25,37.9s8,49.81,8,52.68,9.32,33.51,5.94,35.17-13.49,2.26-20.13-14.34,0-22.49,0-22.49c0,0-12.36-10.25-13.71-19.91s-1.66-17.96-1.66-17.96c0,0-11.68-7.99-19.68-20.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "226.04 280.42 223.47 277.74 271.2 271.72 267.9 275.14 226.04 280.42"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverPlatter);
export default __webpack_public_path__ + "static/media/silverPlatter.f3ca2843c1f8de3922a255add5e77455.svg";
export { ForwardRef as ReactComponent };